import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Outlet } from "react-router";
import Header from "../core/common/header";
import Sidebar from "../core/common/sidebar";
import Unauthorized from "../core/common/unauthorized";
import HorizontalSidebar from "../core/common/horizontal-sidebar";

const Feature = () => {
  const headerCollapse = useSelector((state: any) => state.commonSlice.headerCollapse);
  const mobileSidebar = useSelector((state: any) => state.commonSlice.mobileSidebar);
  const miniSidebar = useSelector((state: any) => state.commonSlice.miniSidebar);
  const expandMenu = useSelector((state: any) => state.commonSlice.expandMenu);
  const dataLayout = useSelector((state: any) => state.themeSetting.dataLayout);
  const dataTheme = useSelector((state: any) => state.themeSetting.dataTheme);
  const dataSidebarAll = useSelector(
    (state: any) => state.themeSetting.dataSidebarAll
  );
  const dataColorAll = useSelector(
    (state: any) => state.themeSetting.dataColorAll
  );
  const dataTopBarColorAll = useSelector(
    (state: any) => state.themeSetting.dataTopBarColorAll
  );
  const dataTopbarAll = useSelector(
    (state: any) => state.themeSetting.dataTopbarAll
  );
  
  // Permissions V2 — "has any access" is simply holding at least one granted key.
  const permissionKeys = useSelector((state: any) => state.permissions?.permissionKeys);
  // Tenancy §3.2 / §7.1: a platform (super) admin has no tenant and therefore no
  // permission keys, but is NOT unauthorized — they get the Companies / Data
  // Sharing sidebar (the Sidebar component filters to those two items itself).
  const isPlatformAdmin = useSelector((state: any) => state.auth?.user?.isPlatformAdmin);
  const hasAnyPermissions =
    !!isPlatformAdmin ||
    (Array.isArray(permissionKeys) && permissionKeys.length > 0);

  useEffect(() => {
    if (dataTheme === "dark") {
      document.documentElement.setAttribute("data-theme", "dark");
    } else {
      document.documentElement.setAttribute("data-theme", "");
    }
  }, [dataTheme]);
  return (
    <>
      <style>
        {`
      :root {
        --sidebar--rgb-picr: ${dataSidebarAll};
        --topbar--rgb-picr:${dataTopbarAll};
        --topbarcolor--rgb-picr:${dataTopBarColorAll};
        --primary-rgb-picr:${dataColorAll};
      }
      
      /* Adjust layout for pages without sidebar */
      [data-layout="without-header"] .page-wrapper {
        margin-left: 0 !important;
        padding-left: 0 !important;
        width: 100% !important;
      }
      
      [data-layout="without-header"] .main-wrapper {
        width: 100% !important;
      }
      
      [data-layout="without-header"] .header {
        width: 100% !important;
        left: 0 !important;
      }
    `}
      </style>
      <div
        className={`
          ${miniSidebar ? "mini-sidebar" : ""}
          ${expandMenu && miniSidebar ? "expand-menu" : ""}
          ${headerCollapse ? "header-collapse" : ""}
          ${mobileSidebar ? "slide-nav" : ""}
        `}
      >
        <div
          className={`main-wrapper 
        ${headerCollapse ? "header-collapse" : ""} 
        ${mobileSidebar ? "slide-nav" : ""}`}
        >
          <Header />
          {dataLayout !== "without-header" && (
            hasAnyPermissions ? <Sidebar /> : <Unauthorized />
          )}
          <HorizontalSidebar />
          <Outlet />
        </div>
        <div className="sidebar-overlay"></div>
      </div>
    </>
  );
};

export default Feature;
